import { UserStateContextType } from 'components/constants/Constants';
import { useUserState } from 'context/User';

export const useGetBrandPortalInfo = (eventKey: string | undefined) => {
  const user = useUserState();
  if (!eventKey || user.type !== UserStateContextType.AUTHENTICATED)
    return undefined;
  return user.user.brandPortalEvent?.find(e => e.key === eventKey);
};
